import chatcontainer from "./chat-container.html";

const chatHandler = require('./chat-handler')
const chatActions = require('./chat-actions')

/****************ELEMENTS*****************/
var htmlQf = {}
var HTMLwasSelected = false
let data = {};

function HTMLselect(detail) {

    const sourceElement = detail.ev?.target || null;

    chatActions.HTMLselect(
        'chat',
        'chat-container',
        sourceElement,
        chatcontainer,
        htmlQf
    )

    HTMLwasSelected = true
}

export function start(detail) {
    if (!HTMLwasSelected) { HTMLselect(detail) }
    obj[detail.actQuickview].start(detail)
}

const obj = {

    show:   { start: (detail) => { show(detail) } },
    hide:   { start: (detail) => { chatActions.hide(detail, htmlQf) } },
    submit: { start: (detail) => { submit(detail) } },
}

function show(detail) {
    // se limpia la variable general
    data = "";
    // se asigna los valores de detail a la variable general data
    data = detail;
    // se muestra el quickview para poder acceder a los elementos
    chatActions.show(detail, htmlQf)
    // se limpia el chat
    chatActions.clearChat()
    // se obtienen los labels estaticos
    const chatContainer = document.getElementById("chat-container");
    const typeEntity = chatContainer.querySelector(".chat-type-entity");
    const typeName = chatContainer.querySelector(".chat-type-name");
    const typeInfo = chatContainer.querySelector(".chat-type-info");
    // se limpian los labels antes de inserta entidad y tipo
    typeEntity.innerHTML = "";
    typeName.innerHTML = "";
    typeInfo.innerHTML = "";
    // se manejan datos especificos para ejecutar verificaciones especificas
    const recordId = data.recordId || 0;
    const question = detail.question || "";
    // si existe una pregunta al momento de mostrar el chat
    if (question !== "") {
        chatActions.setTextInput(question)
        chatHandler.submit({
            "type": data.type,
            "entity": data.entity,
            "recordId": recordId,
            "question": question,
            "data": data.data
        })
    }
    // se el id de la factura es diferente de 0
    if (recordId !== 0) {
        chatHandler.getChats({
            "type": data.type,
            "entity": data.entity,
            "recordId": recordId
        })
    }
    // se asigna el valor valor a los labels especificos
    typeEntity.innerHTML = `Entity: ${detail.entity}`;
    typeName.innerHTML = `Type: ${detail.type}, ID: ${recordId}`;
    typeInfo.innerHTML = `This chat is limited to this entity and to the history`;
    // se limpia la caja de escritura
    chatActions.clearTextInput()
}

function submit(detail) {
    const question = chatActions.getTextInput(detail);
    if (question === '') return;

    chatHandler.submit({
        "type": data.type,
        "entity": data.entity,
        "recordId": data.recordId ?? "0",
        "question": question,
        "data": data.data
    })
}